import { render } from "./ButtonUI.vue?vue&type=template&id=1fbf0413&scoped=true"
import script from "./ButtonUI.vue?vue&type=script&lang=js"
export * from "./ButtonUI.vue?vue&type=script&lang=js"

import "./ButtonUI.vue?vue&type=style&index=0&id=1fbf0413&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbf0413"]])

export default __exports__